import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userDetails: {},
  isAuthenticated: false,
  userProfileDetails: {},
  loginOtpType:"mobile",
  loginUserType:0,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    getUserDetails: (state, action) => {
      state.userDetails = action.payload.userDetails;
      state.isAuthenticated = action.payload.isAuthenticated;
    },
    getUserProfileDetails: (state, action) => {
      state.userProfileDetails = action.payload;
    },
    getUserLogout: (state, action) => {
      state.userDetails = {};
      state.isAuthenticated = false;
    },
    getOtpType: ( state, action) => {
      state.loginOtpType = action.payload;
    },
    getUserType:(state, action) => {
      state.loginUserType = action.payload;
    },
  },
});

export const { getUserDetails, getUserProfileDetails,getUserType, getUserLogout,getOtpType } =
  userSlice.actions;

export default userSlice.reducer;
